import { Injectable } from '@angular/core';
import { CommonService } from "../common.service";
import { UserPreference } from '../../models';
import * as moment from 'moment';
import { WidgethelperService } from "../widgethelper.service";
import { AnalyticsService } from "../analytics.service";
import { BaseService } from "./base.service";
import { HospitalPackedParam } from '../../models/HospitalPackedParam';
import {  errorMessages, appSettings } from "../../settings";
import { OrderFillRateParam } from '../../models/OrderFillRateParam';

@Injectable()
export class OrderfillrateService extends BaseService {

  constructor(private _commonService: CommonService,
    private _widgetHelper: WidgethelperService,
    private _analyticsService: AnalyticsService,) {
      super();
 }  
 
 init(widget: any) {   
    widget.dataLoaded = false;
    widget.Title = 'Order Fill Rate';

    let userPref: UserPreference = this._commonService.getUserPreference();

    let param = new OrderFillRateParam();
    param.CustomerId = userPref.CustomerId;
    param.FacilityId = userPref.FacilityId;
    param.StartDate = new Date(moment().add(-30, "days").format("l"));
    param.EndDate = new Date();

    this._analyticsService.getOrderFillRateSummary(param)
      .subscribe((result: any) => {       
        widget.errorMessage = null;
        if (result && result.length > 0) {
          widget.dataLoaded = false;
          let orderFillRate = []; 
          let lineFillRate = []; 
          let unitFillRate = []; 
          let xAxisData = []; 
          result.forEach(el => {
              let rptdate = null;
              rptdate = el.REPORT_DATE ?
                        this._commonService.formatDate(new Date(el.REPORT_DATE),appSettings.chartDayFormat)
                        : null;
              if (rptdate && xAxisData.indexOf(rptdate) == -1) {
                orderFillRate.push(el.ORDER_FILL_RATE);
                lineFillRate.push(el.LINE_FILL_RATE);
                unitFillRate.push(el.UNIT_FILL_RATE);
                xAxisData.push(rptdate)
              }
          });  
          
          widget.chartOptions = this.customizeChartOptions('',true);
          this.addDataSeries(widget.chartOptions,orderFillRate,'Order Fill Rate','line')     
          this.addDataSeries(widget.chartOptions,lineFillRate,'Line Fill Rate','line')  
          this.addDataSeries(widget.chartOptions,unitFillRate,'Unit Fill Rate','line')                  
          widget.chartOptions.xAxis.data = xAxisData;
          widget.chartOptions.xAxis.axisLabel.rotate = 45;   
          this.addZoomBar(widget.chartOptions);      
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        widget.dataLoaded = true;

       },
       err => {
        console.log('gethospitalordersummary', err);
        widget.errorMessage = errorMessages.apiError;
        widget.dataLoaded = true;
      }
    );
  }

  reload(widget: any) { }

  remove(widget: any) { }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/orderfillrate.service.ts